import { IMyReservationList, IRealTimeHallInfo, TRealtimeWeddinghall } from "@src/types/realtimeBooking";
import axios from "../axios";
import { BASE_URL } from "./../../utils/index";

export const getVenueInfo = (partnerId: string ) => {
    return axios.get<{ data: IRealTimeHallInfo }>(
        `${BASE_URL}/web/v3/halls/consultings/partners/${partnerId}`
    );
};

export const getCalendarSchedule = (partnerId: string) => {
    return axios.get<{ data: any }>(
        `${BASE_URL}/web/v3/halls/consultings/partners/${partnerId}/slots`
    );
};

export const getDaySchedule = (partnerId: string, date:string[]) => {
    return axios.get<{ data: any }>(
        `${BASE_URL}/web/v3/halls/consultings/partners/${partnerId}/slots?visitDates=${date.join(',')}`
    );
};

export const postReservation = (data, uuid) => {
    if(uuid !== ''){
        return axios.post<any>(`${BASE_URL}/web/v3/halls/consultings/reservations`,data, {
                params: {uuid: uuid}
            }
        );
    }else {
        return axios.post<any>(`${BASE_URL}/web/v3/halls/consultings/reservations`,data);
    };
};



//실시간 예약 내역 조회
export const getMyReservationList = (params: {apiKey:string,uuid: string}) => {
  const stringParams = { ...params};
  const p = new URLSearchParams(stringParams).toString();
    return axios.get<IMyReservationList>(`${BASE_URL}/web/v3/halls/consultings/reservations?${p}`);
};


export const getMyReservationDetail = (id:string, params: {apiKey:string,uuid: string, partnerId?:number}) => {
    const stringParams: Record<string, string> = { 
        apiKey: params.apiKey, 
        uuid: params.uuid // 유저 uuid
    };
    if (params.partnerId) {
        stringParams.partnerId = params.partnerId.toString();
    }
    const p = new URLSearchParams(stringParams).toString();
    return axios.get<{ data: any }>(
        `${BASE_URL}/web/v3/halls/consultings/reservations/${id}?${p}`);
};

export const changeReservationDate = (id:string, date, time, uuid) => {
    const data = {
        'date': date,
        'time': `${time}:00`
    }
    return axios.put<{result: number}>(`${BASE_URL}/web/v3/halls/consultings/reservations/${id}/visits?uuid=${uuid}`, data);
};

export const cancelReservation = (id:string, uuid) => {
    return axios.put<{ data: any }>(`${BASE_URL}/web/v3/halls/consultings/reservations/${id}/refund?uuid=${uuid}`);
};


//빠른예약 관련 API
export const getRealtimeHallList = async (params: any) => {
  try {
    // URLSearchParams를 사용하여 쿼리 파라미터 생성
    const searchParams = new URLSearchParams();
    
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (Array.isArray(value)) {
        // 배열인 경우 각 값을 개별 파라미터로 추가
        value.forEach(v => searchParams.append(key, v));
      } else if (value !== null && value !== undefined) {
        searchParams.append(key, value.toString());
      }
    });
    
    const queryString = searchParams.toString();
    const url = `${BASE_URL}/v3/book/halls/consultings/partners${queryString ? `?${queryString}` : ''}`;
    
    const res = await axios.get<{ item: TRealtimeWeddinghall[], total:number}>(url);
    return res.data;
  } catch (err) {
    console.error('err:', err)
    return { item: [], total: 0 };
  }
};